import * as React from 'react';
import { Box, SpaceBetween, Container } from '@amzn/awsui-components-react';
import { ComponentType } from './componentType';

interface ComponentInstallationDetailsProps {
    deviceId: string;
    vin: string;
    componentType: ComponentType;
    serialNumber?: string;
    status?: string;
    notes?: string;
    healthStatus?: string;
    title?: string;
    lastStatusTimestampString?: string;
}

const ComponentInstallationDetails: React.FC<ComponentInstallationDetailsProps> = ({
    deviceId,
    vin,
    componentType,
    serialNumber,
    status,
    notes,
    healthStatus,
    title = 'Component Details',
    lastStatusTimestampString,
}) => {
    const details = [
        <Box key="title" variant="h3">
            {title}
        </Box>,
        <div key="device-id">
            <strong>Device ID:</strong> {deviceId}
        </div>,
        <div key="vin">
            <strong>VIN:</strong> {vin}
        </div>,
        <div key="component-type">
            <strong>Component Type:</strong> {componentType.label}
        </div>,
    ];

    if (serialNumber) {
        details.push(
            <div key="serial-number">
                <strong>Serial Number:</strong> {serialNumber}
            </div>,
        );
    }

    if (status) {
        details.push(
            <div key="status">
                <strong>Status:</strong> {status}
            </div>,
        );
    }

    if (notes) {
        details.push(
            <div key="notes">
                <strong>Notes:</strong> {notes}
            </div>,
        );
    }

    if (healthStatus) {
        details.push(
            <div key="health-status">
                <strong>Health Status:</strong> {healthStatus}
            </div>,
        );
    }

    if (lastStatusTimestampString) {
        details.push(
            <div key="latest-status-timestamp">
                <strong>Latest Status Timestamp:</strong> {lastStatusTimestampString}
            </div>,
        );
    }

    return (
        <Container>
            <SpaceBetween size="xs">{details}</SpaceBetween>
        </Container>
    );
};

export default ComponentInstallationDetails;
